export default __webpack_public_path__ + "static/media/defense-weapons.aa2a6d22.svg";